import styled from "styled-components";

export const Maintitle = styled.h5`
  background: #02a9c7;
  color: #fff;
  padding: 15px;
  text-align: right;
  border-radius: 5px 5px 0 0;
  font-weight: 600;
`;
